module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_09.png?8306c0b872bdaf60a71ba32c42077623";